import { FastpassOrderStatus } from '@hooks-api/types/dataModel/fpOrder'
import { Box } from '@pets-ui/Box/Box'
import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useEffect } from 'react'
import { Redirect, useHistory } from 'react-router-dom-v5'
import AdminHeader from '../../components/admin-header'
import OrderDelivery from '../../components/order-delivery'
import { useAdminOrders } from '../../hooks/use-admin-orders'
import { useCampaign } from '../../hooks/use-campaign'
import { OrderModel } from '../../model/order-model'
import { AdminOrderInfo } from './AdminOrderInfo'
import { AdminOrderStatus } from './AdminOrderStatus'
import { PaymentTip } from './PaymentTip'

export const AdminReview = () => {
  const history = useHistory()
  const adminToken = JSON.parse(sessionStorage.getItem('admin') || '{}')
  const { campaignCodeFromUrl } = useCampaign()
  const { destructuredData: orders } = useAdminOrders()
  const orderModel = orders ? new OrderModel(orders) : null

  useEffect(() => {
    if (orders?.status === FastpassOrderStatus.COMPLETED && !orders.item_confirmed) {
      history.push(`/admin/${campaignCodeFromUrl}/admin-checked`)
    }
  }, [campaignCodeFromUrl, history, orders?.status, orders?.item_confirmed])

  if (typeof adminToken.token === 'undefined') {
    return <Redirect to={`/admin/${campaignCodeFromUrl}/admin-login`} />
  }

  return (
    <>
      <AdminHeader />
      <VStack
        alignItems="center"
        justifyContent="center"
        backgroundColor={colors.grey100}
        marginTop="56px"
        gap={4}
      >
        <VStack width="100%" backgroundColor={colors.white} p={3} gap={4}>
          <PaymentTip />
          <AdminOrderStatus />
          <Box>{orderModel ? <OrderDelivery deliveryInfo={orderModel?.getCustomDeliveryInfo()} /> : <Skeleton height="144px" variant="rounded" />}</Box>
        </VStack>
        <AdminOrderInfo />
      </VStack>
    </>
  )
}

export default AdminReview
